module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_answer-c98d2016af7621ee5378904406c070c4.svg";